import React, { useState, useEffect, useCallback } from 'react';
import BlogBuilder from './pages/BlogBuilder';
import AiTagGenerator from './pages/AiTagGanerator';
import CaptionGenerator from './pages/CaptionGenerator';
import AiNews from './pages/AiNews';
import AdminPage from './pages/AdminPage';
import FeatureRequestPage from './pages/FeatureRequestPage';
import NotFound from './pages/NotFound';
// Feature request modal and Donate/Suggest bar removed per request
import DonatePage from './pages/DonatePage';
import BlogPage from './pages/BlogPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import RefundPolicy from './pages/RefundPolicy';
import PaymentPolicy from './pages/PaymentPolicy';
import { humanizeText } from './Humanizer';
// REMOVED: import { loadStripe } from '@stripe/stripe-js';
// REMOVED: import { Elements, useStripe } from '@stripe/react-stripe-js';
import axios from 'axios';
import './App.css';
import ROUTES from './routes.json';
import { Link, Routes, Route, Navigate } from 'react-router-dom';
import { normalizeRoute } from './utils/routeHelpers';
import Header from './components/Header';
import HumanizerSeoContent from './components/HumanizerSeoContent';
import Footer from './components/Footer';
import PageHelmet from './components/PageHelmet';

// Utility function to get backend URL (sanitize quotes)
const _rawBackend = process.env.REACT_APP_BACKEND_URL || '';
const BACKEND_URL = _rawBackend.replace(/^['"]+|['"]+$/g, '').trim();

const GOOGLE_CLIENT_ID = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').replace(/^['"]+|['"]+$/g, '').trim().replace(/\/+$/,'');

console.log(`Backend URL: ${BACKEND_URL}`)
console.log( GOOGLE_CLIENT_ID)

// REMOVED: const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

// ADDED: Utility function to load the Razorpay script dynamically
const loadRazorpayScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        // script.async = true; // Optional, but good practice
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
};

// -------------------------------------------------------------------------
// 💡 NEW: RazorpayPaymentModal Component (Replaces Stripe PaymentModal)
// -------------------------------------------------------------------------
const RazorpayPaymentModal = ({ onClose, googleId }) => {
  // REMOVED: const stripe = useStripe();
  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentError, setPaymentError] = useState(null);

  const handleRazorpayPayment = async (event) => {
    event.preventDefault();
    
    setIsProcessing(true);
    setPaymentError(null);

    // 1. Load the Razorpay SDK script
    const res = await loadRazorpayScript('https://checkout.razorpay.com/v1/checkout.js');

    if (!res) {
        setPaymentError("Razorpay SDK failed to load. Check your internet connection.");
        setIsProcessing(false);
        return;
    }

    try {
        // 2. Request a new order ID from the backend
        const orderResponse = await axios.post(`${BACKEND_URL}/create-razorpay-order`, {
            googleId: googleId,
        });
        const { orderId, amount, currency } = orderResponse.data;

        // 3. Configure Razorpay options
        const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY_ID, // Public Key from ENV
            amount: amount, 
            currency: currency,
            name: "OneHub AI Humanizer Pro",
            description: "Monthly Pro Access",
            order_id: orderId, 
            handler: async function (response) {
                // 4. Send payment response to backend for verification
                try {
                    const verificationResponse = await axios.post(`${BACKEND_URL}/verify-razorpay-payment`, {
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature,
                        googleId: googleId, // Pass ID for DB lookup
                    });
                    
                    if (verificationResponse.data.status === "success") {
                        // Verification successful, refresh the page to update status
                        window.location.reload(); 
                    } else {
                         setPaymentError("Payment verified but subscription failed to activate.");
                    }
                } catch (error) {
                    console.error('Verification failed:', error);
                    setPaymentError("Payment verification failed. Please contact support.");
                }
            },
            modal: {
                ondismiss: () => {
                    setIsProcessing(false);
                    console.log('Razorpay modal dismissed');
                }
            },
            // Pre-fill fields can be added here
        };
        
        // 5. Open the Razorpay payment modal
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();

    } catch (error) {
        console.error("Error initiating payment:", error);
        setPaymentError(error.response?.data?.error || "Error creating Razorpay order. Try again.");
    } finally {
        // Note: isProcessing is set to false in the modal.ondismiss handler
    }
  };

  return (
    <div className="payment-overlay">
      <div className="payment-box">
        <h4 className="modal-title">Daily Limit Reached</h4>
        <p className="modal-subtitle">Upgrade to **Pro** for unlimited humanization.</p>
        <form onSubmit={handleRazorpayPayment}>
          <button className="upgrade-btn" type="submit" disabled={isProcessing}>
            {isProcessing ? "Processing..." : "Unlock Humanizer for $5.00/month (Test Price)"}
          </button>
        </form>
        {paymentError && <div className="error-message">{paymentError}</div>}
        <div className="modal-footer">
          <p className="wait-text">or wait until next day</p>
          <button className="cancel-btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};


// -------------------------------------------------------------------------
// 💡 App Component (Modified)
// -------------------------------------------------------------------------
function App() {
  // Copy to clipboard for Humanized Version
  const [copySuccess, setCopySuccess] = useState('');
  const handleCopyOutput = () => {
    if (outputText) {
      navigator.clipboard.writeText(outputText)
        .then(() => {
          setCopySuccess('Copied!');
          setTimeout(() => setCopySuccess(''), 1500);
        })
        .catch(() => {
          setCopySuccess('Failed to copy');
          setTimeout(() => setCopySuccess(''), 1500);
        });
    }
  };
  const [inputText, setInputText] = useState('');
  const [outputText, setOutputText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  // isPro state removed (not used in App after routing refactor)
  const [isAdmin, setIsAdmin] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  // Tab state: 'humanizer' or 'resume'
  // activeTab state removed; routing is handled declaratively by react-router
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 760);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  // showMore state moved to Header; remove duplicate here

  // word usage tracking removed (client-side quota logic was disabled).

  //const GOOGLE_CLIENT_ID = `222845145663-n83rq5478m3me77mna719addftes7bq6.apps.googleusercontent.com`;

  const fetchUserStatus = useCallback(async (googleId) => {
    try {
        const response = await axios.get(`${BACKEND_URL}/user-status/${googleId}`);
        // We only track admin flag in App; pro-flag is not needed here
        setIsAdmin(!!response.data.isAdmin);
    } catch (err) {
        console.error("Error fetching user status:", err);
    }
  }, []);

  const handleGoogleLogin = useCallback((response) => {
    // response.credential is a JWT - parse payload to get basic user info
    try {
      const userObject = JSON.parse(atob(response.credential.split('.')[1]));
      // Persist user to sessionStorage so full-page navigations keep the session
      sessionStorage.setItem('user', JSON.stringify(userObject));
      sessionStorage.setItem('google_credential', response.credential);
      setUser(userObject);
      fetchUserStatus(userObject.sub);
      // Upsert user profile to backend so admins can see name/email
      (async () => {
        try {
          await axios.post(`${BACKEND_URL}/api/user/me`, {}, { headers: { Authorization: `Bearer ${response.credential}` } });
        } catch (e) {
          // non-fatal
          console.warn('Failed to upsert user profile', e && (e.message || e));
        }
      })();
      setShowLoginPrompt(false);
    } catch (err) {
      console.error('Failed to parse Google credential', err);
    }
  }, [fetchUserStatus]);

  const handleLogout = () => {
    setUser(null);
    // clear any client-side pro flag in session if used elsewhere
    // clear persisted session
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('google_credential');
    if (window.google) {
      window.google.accounts.id.disableAutoSelect();
    }
  };

  // Google Login useEffect
  useEffect(() => {
    // On mount, restore any existing session from sessionStorage so full page nav keeps user logged in
    try {
      const stored = sessionStorage.getItem('user');
      if (stored) {
        const parsed = JSON.parse(stored);
        setUser(parsed);
        // refresh isPro flag from backend
        fetchUserStatus(parsed.sub);
      }
    } catch (err) {
      console.warn('Failed to restore user from sessionStorage', err);
    }

    if (window.google) {
      // Initialize for header button
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleGoogleLogin,
      });
      
      // Render the button in the header
      window.google.accounts.id.renderButton(
        document.getElementById("google-login-button"),
        { theme: "outline", size: "large", type: "standard" }
      );

      // Render the button inside the login prompt modal when it is visible
      if (document.getElementById("google-login-button-prompt")) {
        window.google.accounts.id.renderButton(
          document.getElementById("google-login-button-prompt"),
          { theme: "outline", size: "large", type: "standard" }
        );
      }
    }
  }, [showLoginPrompt, fetchUserStatus, handleGoogleLogin]); 


  const handleHumanize = () => {
    
    // Unlimited mode: bypass word limit for all users
    // if (!isPro) {
    //   const wordsToProcess = inputText.split(/\s+/).filter(Boolean).length;
    //   const newWordCount = wordCount + wordsToProcess;
    //   
    //   if (newWordCount > FREE_WORD_LIMIT) {
    //     
    //     if (!user) {
    //       setShowLoginPrompt(true); 
    //       return;
    //     }
    //     setShowPaymentModal(true); 
    //     return;
    //   }
    //   
    //   setWordCount(newWordCount);
    //   sessionStorage.setItem('wordUsage', JSON.stringify({ count: newWordCount, date: new Date().toDateString() }));
    // }
    
    setIsLoading(true);
    setError(null);
    setOutputText('');

    try {
      const humanizedText = humanizeText(inputText);
      setOutputText(humanizedText);
    } catch (err) {
      setError("An error occurred while processing the text.");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Head management moved to react-helmet-async on a per-page basis.

  // HumanizerRoute: reuses App's state and handlers to render the humanizer
  // tool UI (keeps most logic in App while allowing declarative routing).
  const HumanizerRoute = () => (
    <section className="tool-area">
      {/* Page-level H1 for /humanizer (only one H1 on the page) */}
      <h1 className="text-3xl font-bold mb-6">AI Text Humanizer – Turn AI Content into Human-Like Writing</h1>
      <PageHelmet
        title={ROUTES.humanizer.title}
        description={ROUTES.humanizer.description}
        canonical={window.location.origin + normalizeRoute(ROUTES.humanizer.path)}
      />
      {/* Login prompt modal */}
      {showLoginPrompt && (
        <div className="modal-overlay">
          <div className="modal-card">
            <h4>Daily Limit Reached</h4>
            <p>Please log in with Google to continue or upgrade to Pro.</p>
            <div id="google-login-button-prompt" className="google-btn-placeholder" />
            <div className="modal-actions">
              <button className="btn ghost" onClick={() => setShowLoginPrompt(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <div className="tool-grid">
        <div className="panel panel-left">
          <label className="sr-only" htmlFor="inputText">Paste text</label>
          <textarea id="inputText" className="input-area" placeholder="Paste your text here..." value={inputText} onChange={(e) => setInputText(e.target.value)} />
          <div className="panel-actions">
            <button className="btn large" onClick={handleHumanize} disabled={isLoading || inputText.length === 0}>
              {isLoading ? 'Humanizing...' : 'Humanize Text'}
            </button>
          </div>
        </div>

        <div className="panel panel-right">
          <div className="panel-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <h3 style={{ margin: 0 }}>Humanized Version</h3>
            <button
              className="btn small copy-btn"
              style={{ marginLeft: 'auto' }}
              onClick={handleCopyOutput}
              disabled={!outputText}
              aria-label="Copy humanized text"
            >
              {copySuccess ? copySuccess : 'Copy'}
            </button>
          </div>
          <div className="output-area" aria-live="polite">
            {isLoading ? (
              <div className="loading">Processing…</div>
            ) : outputText ? (
              <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', margin: 0, background: 'none', border: 'none', fontFamily: 'inherit', fontSize: 'inherit' }}>
                {outputText}
              </pre>
            ) : (
              <span className="placeholder">Your humanized text will appear here.</span>
            )}
          </div>
        </div>
      </div>

      {/* Razorpay modal (unchanged logic) */}
      {showPaymentModal && <RazorpayPaymentModal onClose={() => setShowPaymentModal(false)} googleId={user?.sub} />}
      {error && <div className="error-inline">{error}</div>}

      {/* ADDED/UPDATED: SEO content for Humanizer (What / Why / When / Stories / FAQ) */}
  <section className="seo-section">
        <div className="seo-inner">
          <header className="seo-header">
            <h2>About OneAI Text Humanizer</h2>
            <p className="seo-lead">Fast drafts created with AI and carefully shaped by people — clearer, warmer, and ready for your audience.</p>
          </header>

          <div className="seo-grid">
            <article className="seo-card">
              <h3>What is the Humanizer?</h3>
              <p>
                The OneAI Humanizer turns prompt-driven drafts into readable, human-shaped copy. Every output is produced by AI and refined with human-guided controls to ensure tone and clarity.
              </p>
            </article>

            <aside className="seo-cta-grid" style={{ display: 'grid', gap: 10 }}>
              <h4 style={{ marginTop: 0 }}>Explore our tools</h4>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <Link to={normalizeRoute(ROUTES.blogBuilder.path)} className="btn ghost" style={{ padding: '8px 12px' }}>Try Blog Builder</Link>
                <Link to={normalizeRoute(ROUTES.tagGenerator.path)} className="btn ghost" style={{ padding: '8px 12px' }}>Meta Tag Generator</Link>
                <Link to={normalizeRoute(ROUTES.captionGenerator.path)} className="btn ghost" style={{ padding: '8px 12px' }}>Caption Generator</Link>
                <Link to={normalizeRoute(ROUTES.aiNews.path)} className="btn ghost" style={{ padding: '8px 12px' }}>AI News</Link>
                <Link to={normalizeRoute(ROUTES.blog.path)} className="btn ghost" style={{ padding: '8px 12px' }}>Read Blog</Link>
                <Link to={normalizeRoute(ROUTES.contact.path)} className="btn ghost" style={{ padding: '8px 12px' }}>Contact</Link>
                <Link to={normalizeRoute(ROUTES.about.path)} className="btn ghost" style={{ padding: '8px 12px' }}>About</Link>
                <Link to={normalizeRoute(ROUTES.humanizer.path)} className="btn ghost" style={{ padding: '8px 12px' }}>Humanizer</Link>
              </div>
            </aside>

            <article className="seo-card">
              <h3>Why use it?</h3>
              <ul>
                <li>Create engaging content fast, then polish it to a human standard.</li>
                <li>Keep brand voice consistent with simple human-led settings.</li>
                <li>Save editing time while maintaining a natural voice.</li>
              </ul>
            </article>

            <article className="seo-card">
              <h3>When to use it</h3>
              <p>From support replies to blog drafts and product copy — start with an AI draft and finish with human judgment for best results.</p>
            </article>
          </div>

          <section className="stories">
            <h3>Short stories — real improvements</h3>
            <div className="story-list">
              <div className="story">
                <strong>Startup blog:</strong>
                <p>Drafted by AI, shaped by an editor — increased time-on-page and softened technical voice to speak to readers.</p>
              </div>
              <div className="story">
                <strong>Support responses:</strong>
                <p>Humanized replies reduced confusion and follow-ups while keeping turnaround fast.</p>
              </div>
              <div className="story">
                <strong>Product listings:</strong>
                <p>Combined AI efficiency with human emphasis on benefits, improving conversions in tests.</p>
              </div>
            </div>
          </section>

          <section className="faq">
            <h3>Frequently Asked Questions</h3>
            {/* FAQ details omitted for brevity, kept same as before */}
          </section>
        </div>
      </section>

      {/* New: Extended SEO content for Humanizer (reusable components) */}
      <HumanizerSeoContent />
    </section>
  );

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth <= 760;
      setIsMobile(mobile);
      if (!mobile) setShowMobileMenu(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Dedupe nav elements on mount.
  // If for some reason two navs are rendered (legacy markup, injection, or build artifact),
  // keep the first and remove extra copies so the UI shows only a single navigation bar.
  useEffect(() => {
    const navs = document.querySelectorAll('.nav');
    if (navs.length > 1) {
      console.warn('Multiple .nav elements detected — removing duplicates to avoid UI duplication.');
      // Keep the first nav, remove the rest
      for (let i = 1; i < navs.length; i++) {
        try { navs[i].remove(); } catch (e) { /* ignore removal errors */ }
      }
    }
  }, []);

  return (
    <div className="app-root">
      <div className="app-card">
        {/* Header component (moved out of App.js for reuse and clarity) */}
        <Header
          isAdmin={isAdmin}
          user={user}
          isMobile={isMobile}
          showMobileMenu={showMobileMenu}
          setShowMobileMenu={setShowMobileMenu}
          handleLogout={handleLogout}
          setShowLoginPrompt={setShowLoginPrompt}
        />

        {/* Main content rendered via react-router <Routes> */}
        <main className="main">
          <Routes>
            <Route path="/" element={<HumanizerRoute />} />
            <Route path={ROUTES.humanizer.path} element={<HumanizerRoute />} />
            <Route path={ROUTES.blogBuilder.path} element={<BlogBuilder />} />
            <Route path={ROUTES.tagGenerator.path} element={<AiTagGenerator />} />
            <Route path={ROUTES.captionGenerator.path} element={<CaptionGenerator />} />
            <Route path={ROUTES.aiNews.path} element={<AiNews />} />
            <Route path={`${ROUTES.aiNews.path.replace(/\/+$/,'')}/:slug`} element={<AiNews />} />
            <Route path={ROUTES.admin.path} element={<AdminPage backendUrl={BACKEND_URL} />} />
            <Route path={ROUTES.featureRequest.path} element={<FeatureRequestPage backendUrl={BACKEND_URL} />} />
            <Route path={ROUTES.blog.path} element={<BlogPage />} />
            <Route path={`${ROUTES.blog.path.replace(/\/+$/,'')}/:slug`} element={<BlogPage />} />
            <Route path={ROUTES.contact.path} element={<ContactPage />} />
            <Route path={ROUTES.donate.path} element={<DonatePage backendUrl={BACKEND_URL} />} />
            <Route path={ROUTES.privacy.path} element={<PrivacyPolicy />} />
            <Route path={ROUTES.terms.path} element={<TermsOfService />} />
            <Route path={ROUTES.refund.path} element={<RefundPolicy />} />
            <Route path={ROUTES.payment.path} element={<PaymentPolicy />} />
            <Route path={ROUTES.about.path} element={<AboutPage />} />
            {/* Show a 404 page for unmatched client routes instead of silently redirecting */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        

        {/* Footer component */}
        <Footer />
        {/* Feature request modal and persistent donate/suggest bar removed per admin request */}
      </div>
    </div>
  );
}

// Render Feature Request Modal at root level so it overlays the app
// The modal will POST to the backend URL defined earlier in this file as BACKEND_URL
// We conditionally render it here so the header button can toggle it.

// Note: keep default export unchanged

export default App;


